import { useEffect, useRef } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import { Flex } from 'foundations-components/components/Flex';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { PAYMENTS_IFRAME_ALLOW, PAYMENTS_IFRAME_SANDBOX } from '../constants/IFrameSandbox';
import { trackPageView, trackInteraction } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmbeddedContentPage({
  src,
  title,
  breadcrumbs,
  subscreen,
  footer,
  onMessage = () => {},
  onWindowMessage,
  sandbox = PAYMENTS_IFRAME_SANDBOX
}) {
  const history = useHistory();
  const iframeRef = useRef(null);
  const onWindowMessageRef = useRef(onWindowMessage);
  useEffect(() => {
    trackPageView(subscreen);
  }, [subscreen]);
  useEffect(() => {
    onWindowMessageRef.current = onWindowMessage;
  }, [onWindowMessage]);
  useEffect(() => {
    if (!onWindowMessageRef.current) return undefined;
    let expectedOrigin;
    try {
      expectedOrigin = new URL(src).origin;
    } catch (_unused) {
      return undefined;
    }
    const handleWindowMessage = message => {
      var _iframeRef$current;
      if (message.origin === expectedOrigin && message.source === ((_iframeRef$current = iframeRef.current) === null || _iframeRef$current === void 0 ? void 0 : _iframeRef$current.contentWindow)) {
        var _onWindowMessageRef$c;
        (_onWindowMessageRef$c = onWindowMessageRef.current) === null || _onWindowMessageRef$c === void 0 || _onWindowMessageRef$c.call(onWindowMessageRef, message);
      }
    };
    window.addEventListener('message', handleWindowMessage);
    return () => window.removeEventListener('message', handleWindowMessage);
  }, [src]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    flexGrow: 1,
    backgroundColor: "fill-surface-default",
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      flush: false,
      "data-test-id": "embedded-content-breadcrumbs",
      marginInlineStart: "900",
      marginBlockStart: "500",
      paddingBlockEnd: "400",
      paddingInlineStart: "0",
      children: breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return isLast ? /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: breadcrumb.label,
            options: breadcrumb.options
          })
        }, index) : /*#__PURE__*/_jsx(Link, {
          onClick: () => {
            trackInteraction('breadcrumb-clicked', {
              destination: breadcrumb.href || '/'
            });
            history.push(breadcrumb.href || '/');
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: breadcrumb.label,
            options: breadcrumb.options
          })
        }, index);
      })
    }), /*#__PURE__*/_jsx(IFrame, {
      innerRef: iframeRef,
      src: src,
      onReady: () => {},
      onMessage: onMessage,
      allow: PAYMENTS_IFRAME_ALLOW,
      iframePassthruProps: {
        'data-test-id': 'embedded-content-iframe',
        sandbox,
        style: {
          border: 'none',
          width: '100%',
          flexGrow: 1,
          backgroundColor: 'white'
        },
        title
      }
    }), footer]
  });
}